import { createSlice } from "@reduxjs/toolkit";
import { initialState } from "./initialState";
import { schedulingReducer } from "./reducer";
import { SchedulingTypes } from "./schedulingTypes";
import {
  AddSchedulingCommentAction,
  AddSchedulingEstimateAction,
  getAllClientSchedulingListAction,
  getAllUsersSchedulingListAction,
  getClientJobSchedulingListAction,
  getClientUserSchedulingListAction,
  getManagerNewRequestList,
  getSingleJobsScheduledListAction,
  getSchedulingBandWidthAction,
  getSchedulingCalendar,
  getSchedulingCommentListAction,
  getSchedulingEmployeeApprovedListAction,
  getSchedulingReEstimateListAction,
  getSchedulingUserViewListAction,
  getViewRequestAction,
  updateRequestAction,
  getAllUserMappedToJobAction,
  getUserAvailabilityReportAction,
} from "./action";

export const schedulingSlice = createSlice({
  name: "scheduling",
  initialState,
  reducers: schedulingReducer,
  extraReducers: {
    // [getSchedulingUserViewListAction.pending.toString()]: (state: SchedulingTypes) => ({
    //   ...state,
    //   fetching: true,
    // }),
    // [getSchedulingUserViewListAction.fulfilled.toString()]: (
    //   state: SchedulingTypes,
    //   { payload }
    // ) => {
    //   const { success, message, result, status_code } = payload;

    //   if (success === 0) {
    //     return {
    //       ...state,
    //       fetching: false,
    //       success,
    //       statusCode: status_code,
    //       error: message,
    //     };
    //   }

    //   return {
    //     ...state,
    //     fetching: false,
    //     statusCode: status_code,
    //     success,
    //   };
    // },
    // [getSchedulingUserViewListAction.rejected.toString()]: (
    //   state: SchedulingTypes,
    //   { error }
    // ) => ({
    //   ...state,
    //   fetching: false,
    //   success: 0,
    //   error: error?.message,
    // }),
    [getSchedulingUserViewListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSchedulingUserViewListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      //  const {data}=payload;
      const { success, message, status_code, result, total_count } = payload;
      if (success === 0) {
        return {
          // ...state,
          // fetching: false,
          // error: message,
          // statusCode: status_code,
          // success,
          // schedulingUserViewListing: result,
          // userViewListTotal: total_count,
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,

        fetching: false,

        success,

        schedulingUserViewListing: result,

        userViewListTotal: total_count,
      };
    },
    [getSchedulingUserViewListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    // aprroved
    [getSchedulingEmployeeApprovedListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSchedulingEmployeeApprovedListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      //  const {data}=payload;
      const { success, message, status_code, result, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        employeeApprovedList: result,
        employeeAprrovedTotalCount: total_count,
      };
    },
    [getSchedulingEmployeeApprovedListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
    // comment
    [getSchedulingCommentListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      commentFetching: true,
    }),
    [getSchedulingCommentListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      //  const {data}=payload;
      const { success, message, status_code, result, total_count } = payload;
      if (success === 0) {
        return {
          ...state,
          commentFetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        commentFetching: false,
        success,
        commentList: result,
        commentListTotalCount: total_count,
      };
    },
    [getSchedulingCommentListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      commentFetching: false,
      success: 0,
      error: error.message,
    }),

    //
    [getSchedulingBandWidthAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSchedulingBandWidthAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, message, status_code, result } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        previousHours: result?.hours,
        dailyHours:result
        // userViewListTotal:total_count
      };
    },

    [getSchedulingBandWidthAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    // add
    [AddSchedulingEstimateAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [AddSchedulingEstimateAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
          // error: error.message,
        };
      }
      else{
        return {
          ...state,
          fetching: false,
          statusCode: status_code,
          success,
          message,
        };
      }
     
    },
    [AddSchedulingEstimateAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getManagerNewRequestList.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getManagerNewRequestList.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      //  const {data}=payload;
      const { success, message, status_code, result, total_count } = payload;

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        schedulingManagerViewNewRequestsListing: result,
        managerNewRequestCount: total_count,
      };
    },
    [getManagerNewRequestList.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    // //

    // [getSchedulingBandWidthAction.pending.toString()]: (
    //   state: SchedulingTypes
    // ) => ({
    //   ...state,
    //   fetching: true,
    // }),
    // [getSchedulingBandWidthAction.fulfilled.toString()]: (
    //   state: SchedulingTypes,
    //   { payload }
    // ) => {
    //   //  const {data}=payload;
    //   const { success, message, status_code, result } = payload;
    //   if (success === 0) {
    //     return {
    //       ...state,
    //       fetching: false,
    //       error: message,
    //       statusCode: status_code,
    //       success,
    //     };
    //   }
    //   return {
    //     ...state,
    //     fetching: false,
    //     success,
    //     previousHours: result?.hours,
    //     // userViewListTotal:total_count
    //   };
    // },

    // [getSchedulingBandWidthAction.rejected.toString()]: (
    //   state: SchedulingTypes,
    //   { error }
    // ) => ({
    //   ...state,
    //   fetching: false,
    //   success: 0,
    //   error: error.message,
    // }),

    // add

    ////request  view  manager
    [getViewRequestAction.pending.toString()]: (state: SchedulingTypes) => ({
      ...state,
      fetching: true,
    }),
    [getViewRequestAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      //  const {data}=payload;
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        requestView: result,
        message
        // userViewListTotal:total_count
      };
    },

    [getViewRequestAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),

    //   add comment
    [AddSchedulingCommentAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      commentFetching: true,
    }),
    [AddSchedulingCommentAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if (success === 0) {
        return {
          ...state,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        commentFetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [AddSchedulingCommentAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      commentFetching: false,
    }),
//  re estimate 
[getSchedulingReEstimateListAction.pending.toString()]: (
  state: SchedulingTypes
) => ({
  ...state,
  fetching: true,
}),
[getSchedulingReEstimateListAction.fulfilled.toString()]: (
  state: SchedulingTypes,
  { payload }
) => {
  //  const {data}=payload;

  const { success, message, status_code, result, total_count } = payload;
  if (success === 0) {
    return {
      ...state,
      fetching: false,
      error: message,
      statusCode: status_code,
      success,
    };
  }
  return {
    ...state,
    fetching: false,
    success,
    reEstimateDataList: result,
    reEstimateDataTotalCount: total_count,
  };
},
[getSchedulingReEstimateListAction.rejected.toString()]: (
  state: SchedulingTypes,
  { error }
) => ({
  ...state,
  fetching: false,
  success: 0,
  error: error.message,
}),

////anuj code start

    [getSchedulingCalendar.pending.toString()]: (state: SchedulingTypes) => ({
      ...state,
      fetching: true,
    }),
    [getSchedulingCalendar.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      //  const {data}=payload;
      const { success, message, status_code, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          statusCode: status_code,
          success,
        };
      }
      return {
        ...state,
        fetching: false,
        success,
        calendarData: result,
        message
        // userViewListTotal:total_count
      };
    },

    [getSchedulingCalendar.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      fetching: false,
      success: 0,
      error: error.message,
    }),
     [updateRequestAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [updateRequestAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
     

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
      };
    },

    [updateRequestAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
     [getAllUsersSchedulingListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllUsersSchedulingListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
     

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        allusersScheduleList:result[0]?.data,
        allusersScheduleTotalCount:result[0]?.user_count
      };
    },

    [getAllUsersSchedulingListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    [getAllClientSchedulingListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllClientSchedulingListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
     

      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        allClientScheduleList:result[0]?.data,
        allClientScheduleTotalCount:result[0]?.total_count
      };
    },

    [getAllClientSchedulingListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getClientUserSchedulingListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientUserSchedulingListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        clientUserSchedulingList:result[0]?.data ? result[0]?.data:  [],
        clientUserSchedulingListTotal:result[0]?.user_count 
      };
    },

    [getClientUserSchedulingListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    // client job
    [getClientJobSchedulingListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getClientJobSchedulingListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        clientJobSchedulingList:result[0]?.data ? result[0]?.data:  [],
        clientJobSchedulingTotal:result[0]?.job_count 
      };
    },

    [getClientJobSchedulingListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getSingleJobsScheduledListAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getSingleJobsScheduledListAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message,sum_of_total_hours, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        singleJobScheduledHoursSum:sum_of_total_hours,
        singleJobScheduledHoursList:result
      };
    },
    [getSingleJobsScheduledListAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),

    [getAllUserMappedToJobAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),
    [getAllUserMappedToJobAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message,sum_of_total_hours, result } = payload;
      if (success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        allUserMappedToJob:result[0]?.data ? result[0]?.data:  [],
        clientJobSchedulingTotal:result[0]?.user_count 
      };
    },
    [getAllUserMappedToJobAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }),
    
    // availability report
    [getUserAvailabilityReportAction.pending.toString()]: (
      state: SchedulingTypes
    ) => ({
      ...state,
      fetching: true,
    }),

    [getUserAvailabilityReportAction.fulfilled.toString()]: (
      state: SchedulingTypes,
      { payload }
    ) => {
      const { success, status_code, message, result } = payload;

      if(success === 0) {
        return {
          ...state,
          fetching: false,
          error: message,
          success,
          statusCode: status_code,
        };
      }
      return {
        ...state,
        fetching: false,
        statusCode: status_code,
        success,
        message,
        usersAvailabilityReportData: result[0]?.data,
        usersAvailabilityTotalCount: result[0]?.user_count,
        daysTotal: result[0]?.day_totals[0]?.day_totals,
      };
    },

    [getUserAvailabilityReportAction.rejected.toString()]: (
      state: SchedulingTypes,
      { error }
    ) => ({
      ...state,
      success: 0,
      error: error?.message,
      fetching: false,
    }) 

  },
});
export const {
  resetSchedulingUserViewListing,
  resetSchedulingError,
  resetSchedulingSuccess,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingFetching,
  resetSchedulingPrevoiusHour,
  resetSchedulingUserViewTotalCount,
  resetManagerNewRequest,
  resetSchedulingCommentListing,
  resetSchedulingApprovedListing,
  resetSchedulingApproveTotalCount,
  resetManagerNewRequestCount,
  resetReEstimateDataList,
  resetReEstimateDataTotalCount,
  resetCalendarData,
  resetRequestView,
  resetDailyHours,
  resetAllusersScheduleList,
  resetAllusersScheduleTotalCount,
  resetAllClientScheduleList,
  resetAllClientScheduleTotalCount,
  resetClientUserSchedulingList,
  resetClientUserSchedulingListTotal,
  resetClientJobSchedulingList,
  resetClientJobSchedulingTotal,
  resetSingleJobScheduledHoursSum,
  resetJobScheduledHoursList,
  resetAllUserMappedToJobList,
  resetUsersAvailabilityReportData,
  resetUsersAvailabilityTotalCount
} = schedulingSlice.actions;
